import type { ITreeNode } from '@platform/core/types';
import { orderTree } from './orderTree';

/**
 * Типові значення шляхів для нового запису (UIUX/field-types/area-path, iteration-path; прототип createRecord): напрям — корінь
 * дерева воркспейсу, ітерація — найглибший вузол, що містить сьогоднішню дату (поточний спринт). Немає — null. Чиста функція.
 */
export function treeDefault(nodes: ITreeNode[], kind: 'area' | 'iteration', today: string): string | null {
  const ordered = orderTree(nodes);
  if (kind === 'area') return ordered.find((o) => o.depth === 0)?.node.id ?? null;
  const current = ordered
    .filter((o) => o.node.startDate && o.node.endDate && o.node.startDate <= today && today <= o.node.endDate)
    .reduce<(typeof ordered)[number] | null>((best, o) => (!best || o.depth > best.depth ? o : best), null);
  return current?.node.id ?? null;
}
